import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    locale: 'en',
    user: undefined,
    metadata: {}
  },
  mutations: {
    // Updates the account
    setAccount (state, payload) {
      state.user.account = Object.assign({}, payload);
    },

    // Sets the locale
    setLocale (state, payload) {
      state.locale = payload;
    },

    // Updates the metadata
    setMetadata (state, payload) {
      state.metadata = Object.assign({}, payload);
    },

    // Updates the user
    setUser (state, payload) {
      state.user = Object.assign({}, payload);
    },

    // Logs the user out
    unsetUser (state) {
      state.user = undefined;
    }
  },
  plugins: [createPersistedState()]
});
